export const documentLockTranslations = {
  de: {
    advanceDeductibleTax: 'Abziehbare Vorsteuer',
    advanceDeclaredPrepaid: 'Laut Lieferantenbeleg vorausbezahlt',
    advanceDeclaredDue: 'Laut Lieferantenbeleg zu zahlen',
    advanceOriginalReview: 'Bitte den Originalbeleg auf Anzahlung und Restbetrag prüfen.',
    invoiceKind: 'Rechnungsart',
    standardInvoice: 'Rechnung',
    advanceRequest: 'Anzahlungsanforderung',
    finalInvoice: 'Schlussrechnung',
    chooseAdvances: 'Anzahlungsanforderungen auswählen',
    previousPage: 'Zurück',
    nextPage: 'Weiter',
    advanceReviewHint: 'Der angerechnete Betrag wird vor dem Festschreiben geprüft.',
    advancePayment: 'Zahlungseingang',
    advanceReview: 'Anzahlungen prüfen',
    advanceReviewFailed: 'Die Anzahlungsprüfung ist nicht verfügbar.',
    advanceGross: 'Angerechnet brutto',
    advanceNet: 'Netto',
    advanceTax: 'Umsatzsteuer',
    advanceDue: 'Noch zu zahlen',
    title: 'Festschreiben und Voraussetzungen',
    failed: 'Festschreiben fehlgeschlagen',
    succeeded: 'Beleg festgeschrieben',
    openCustomer: 'USt-IdNr. beim Kunden prüfen',
    openEvidence: 'Nachweise im Dokumentenarchiv öffnen',
    correct: '{{field}} korrigieren',
    context: 'Umgebung: {{environment}} · Betriebsmodus: {{mode}} · Belegzuordnung: {{origin}}',
    TEST: 'Testbeleg',
    UNMARKED: 'Keine Testzuordnung nachgewiesen',
    unsaved: 'Ungespeicherte Änderungen: Speichern Sie den Beleg vor dem Festschreiben.',
    checking: 'Voraussetzungen werden geprüft …',
    checkFailed: 'Die Vorprüfung ist nicht verfügbar. Wiederholen Sie sie vor dem Festschreiben.',
    ready:
      'Die gespeicherte Fassung kann festgeschrieben werden. Beim Ausführen wird erneut geprüft.',
    reload: 'Beleg neu laden',
    history: 'Festschreibungsversuche',
    historyFailed: 'Die Versuchshistorie konnte nicht geladen werden.',
    empty: 'Noch keine Festschreibungsversuche.',
    issues: {
      permission:
        'Für das Festschreiben fehlt die Berechtigung. Wenden Sie sich an Ihre Administration.',
      version:
        'Der Beleg wurde zwischenzeitlich geändert. Laden Sie ihn erneut und prüfen Sie die Änderungen.',
      locked: 'Der Beleg ist bereits festgeschrieben. Laden Sie den aktuellen Stand.',
      status: 'Ein stornierter Beleg kann nicht festgeschrieben werden.',
      required:
        'Für diese Belegart fehlen Pflichtangaben. Ergänzen Sie die genannten Felder und speichern Sie den Beleg.',
      modeMissing:
        'Der Betriebsmodus ist unbekannt. Die Administration muss den Mandantenstatus prüfen.',
      modeCleanup:
        'Während der Bereinigung sind Änderungen gesperrt. Warten Sie auf deren Abschluss beziehungsweise Klärung durch die Administration.',
      modeRecord:
        'Der Beleg gehört nicht zur aktuellen Betriebsphase. Öffnen Sie einen Beleg dieser Phase; historische Belege werden nicht umklassifiziert.',
      vatUnavailable:
        'Die letzte USt-ID-Prüfung war nicht verfügbar. Die innergemeinschaftliche Auswahl und Festschreibung bleiben möglich; holen Sie die Prüfung beim Kunden nach.',
      vatRequired:
        'Ein aktueller gültiger USt-ID-Nachweis ist noch offen. Die innergemeinschaftliche Auswahl und Festschreibung bleiben möglich; prüfen Sie die USt-ID beim Kunden.',
      modeVat:
        'Die USt-ID-Prüfung ist noch offen; externe VIES-Aufrufe sind im Einführungsmodus gesperrt. Die innergemeinschaftliche Auswahl und Festschreibung bleiben möglich.',
      taxPrerequisites:
        'Lieferziel, Unternehmereigenschaft oder Warenart belegen die Steuerbefreiung nicht. Prüfen Sie die Steuerentscheidung.',
      transport:
        'Der Versandnachweis wird für die steuerfreie Rechnung benötigt. Für Angebot und Auftrag ist er ein Hinweis auf den späteren Schritt. Verknüpfen Sie zur Rechnungsfestschreibung einen Lieferschein oder geeigneten Nachweis.',
      overridePermission:
        'Für die Abweichung von der Steuerempfehlung fehlt die Berechtigung. Übernehmen Sie die Empfehlung oder lassen Sie die Abweichung berechtigt prüfen.',
      overrideReason:
        'Begründen Sie die Abweichung von der Steuerempfehlung mit mindestens zehn Zeichen und speichern Sie den Beleg.',
      technical:
        'Die Festschreibung konnte technisch nicht abgeschlossen werden. Laden Sie den Beleg erneut und nennen Sie dem Support die Fehlerreferenz.',
    },
    fields: {
      billingAddress_recipient: 'Empfänger',
      billingAddress_postalCode: 'Rechnungsanschrift: Postleitzahl',
      billingAddress_city: 'Rechnungsanschrift: Ort',
      billingAddress_countryCode: 'Rechnungsanschrift: Land',
      shippingAddress_postalCode: 'Lieferanschrift: Postleitzahl',
      shippingAddress_city: 'Lieferanschrift: Ort',
      documentDate: 'Belegdatum',
      items: 'Positionen',
      taxStrategy: 'Steuerentscheidung',
      taxOverrideReason: 'Begründung der Steuerabweichung',
    },
  },
  en: {
    advanceDeductibleTax: 'Deductible input VAT',
    advanceDeclaredPrepaid: 'Prepaid on supplier original',
    advanceDeclaredDue: 'Due on supplier original',
    advanceOriginalReview: 'Review the original for advance deductions and the remaining amount.',
    invoiceKind: 'Invoice type',
    standardInvoice: 'Invoice',
    advanceRequest: 'Advance request',
    finalInvoice: 'Final invoice',
    chooseAdvances: 'Select advance requests',
    previousPage: 'Previous',
    nextPage: 'Next',
    advanceReviewHint: 'The amount applied is reviewed before finalization.',
    advancePayment: 'Payment received',
    advanceReview: 'Review advances',
    advanceReviewFailed: 'Advance review is unavailable.',
    advanceGross: 'Applied gross',
    advanceNet: 'Net',
    advanceTax: 'VAT',
    advanceDue: 'Amount due',
    title: 'Finalize and prerequisites',
    failed: 'Finalization failed',
    succeeded: 'Document finalized',
    openCustomer: 'Verify VAT ID on the customer record',
    openEvidence: 'Open evidence in the document archive',
    correct: 'Correct {{field}}',
    context:
      'Environment: {{environment}} · Operating mode: {{mode}} · Document provenance: {{origin}}',
    TEST: 'Test document',
    UNMARKED: 'No test assignment recorded',
    unsaved: 'Unsaved changes: save the document before finalizing.',
    checking: 'Checking prerequisites …',
    checkFailed: 'Preflight is unavailable. Retry it before finalizing.',
    ready: 'The saved version can be finalized. All checks run again on execution.',
    reload: 'Reload document',
    history: 'Finalization attempts',
    historyFailed: 'Attempt history could not be loaded.',
    empty: 'No finalization attempts yet.',
    issues: {
      permission:
        'You do not have permission to finalize this document. Contact your administrator.',
      version: 'The document has changed. Reload it and review the changes.',
      locked: 'The document is already finalized. Reload its current state.',
      status: 'A cancelled document cannot be finalized.',
      required:
        'Required fields for this document type are missing. Complete the indicated fields and save.',
      modeMissing: 'The operating mode is unknown. Ask an administrator to check the tenant state.',
      modeCleanup:
        'Changes are blocked during cleanup. Wait for completion or ask an administrator to resolve the cleanup failure.',
      modeRecord:
        'This document does not belong to the current operating phase. Open a document from this phase; historical documents are not reclassified.',
      vatUnavailable:
        'The last VAT-ID check was unavailable. Intra-community selection and finalization remain available; complete the check on the customer record.',
      vatRequired:
        'Current valid VAT-ID evidence is still outstanding. Intra-community selection and finalization remain available; verify the customer VAT ID.',
      modeVat:
        'The VAT-ID check is outstanding; external VIES calls are disabled in introduction mode. Intra-community selection and finalization remain available.',
      taxPrerequisites:
        'The destination, business status or supply type does not support tax exemption. Review the tax decision.',
      transport:
        'Transport evidence is required for the tax-exempt invoice. For quotes and orders this is a reminder for a later step. Link a delivery note or suitable evidence before finalizing the invoice.',
      overridePermission:
        'You cannot override the tax recommendation. Apply it or ask an authorized user to review the exception.',
      overrideReason:
        'Explain the tax override using at least ten characters and save the document.',
      technical:
        'Finalization could not be completed due to a technical error. Reload the document and give support the error reference.',
    },
    fields: {
      billingAddress_recipient: 'Recipient',
      billingAddress_postalCode: 'Billing postal code',
      billingAddress_city: 'Billing city',
      billingAddress_countryCode: 'Billing country',
      shippingAddress_postalCode: 'Shipping postal code',
      shippingAddress_city: 'Shipping city',
      documentDate: 'Document date',
      items: 'Items',
      taxStrategy: 'Tax decision',
      taxOverrideReason: 'Tax override reason',
    },
  },
  fr: {
    advanceDeductibleTax: 'TVA déductible',
    advanceDeclaredPrepaid: 'Acompte selon la facture fournisseur',
    advanceDeclaredDue: 'Solde selon la facture fournisseur',
    advanceOriginalReview: 'Vérifiez les acomptes et le solde sur la facture originale.',
    invoiceKind: 'Type de facture',
    standardInvoice: 'Facture',
    advanceRequest: 'Demande d’acompte',
    finalInvoice: 'Facture finale',
    chooseAdvances: 'Sélectionner les demandes d’acompte',
    previousPage: 'Précédent',
    nextPage: 'Suivant',
    advanceReviewHint: 'Le montant imputé est vérifié avant la validation.',
    advancePayment: 'Paiement reçu',
    advanceReview: 'Vérifier les acomptes',
    advanceReviewFailed: 'La vérification des acomptes est indisponible.',
    advanceGross: 'Montant TTC imputé',
    advanceNet: 'Montant HT',
    advanceTax: 'TVA',
    advanceDue: 'Reste à payer',
    title: 'Finalisation et prérequis',
    failed: 'Échec de finalisation',
    succeeded: 'Document finalisé',
    openCustomer: 'Vérifier la TVA dans la fiche client',
    openEvidence: 'Ouvrir les preuves dans les archives',
    correct: 'Corriger {{field}}',
    context: 'Environnement : {{environment}} · Mode : {{mode}} · Origine du document : {{origin}}',
    TEST: 'Document de test',
    UNMARKED: 'Aucune affectation de test enregistrée',
    unsaved: 'Modifications non enregistrées : enregistrez avant de finaliser.',
    checking: 'Vérification des prérequis …',
    checkFailed: 'La vérification préalable est indisponible. Réessayez avant de finaliser.',
    ready:
      'La version enregistrée peut être finalisée. Les contrôles sont répétés lors de l’exécution.',
    reload: 'Recharger le document',
    history: 'Tentatives de finalisation',
    historyFailed: 'Impossible de charger l’historique des tentatives.',
    empty: 'Aucune tentative de finalisation.',
    issues: {
      permission:
        'Vous n’avez pas le droit de finaliser ce document. Contactez votre administrateur.',
      version: 'Le document a changé. Rechargez-le et vérifiez les modifications.',
      locked: 'Le document est déjà finalisé. Rechargez son état actuel.',
      status: 'Un document annulé ne peut pas être finalisé.',
      required:
        'Des champs obligatoires pour ce type de document manquent. Complétez les champs indiqués et enregistrez.',
      modeMissing:
        'Le mode de fonctionnement est inconnu. Demandez à l’administrateur de vérifier l’état du tenant.',
      modeCleanup:
        'Les modifications sont bloquées pendant le nettoyage. Attendez sa fin ou demandez à l’administrateur de résoudre l’échec.',
      modeRecord:
        'Ce document n’appartient pas à la phase actuelle. Ouvrez un document de cette phase ; les documents historiques ne sont pas reclassés.',
      vatUnavailable:
        'Le dernier contrôle de TVA était indisponible. La sélection intracommunautaire et la validation restent possibles ; effectuez le contrôle dans la fiche client.',
      vatRequired:
        'Un justificatif de TVA valide et récent reste à obtenir. La sélection intracommunautaire et la validation restent possibles ; vérifiez le numéro du client.',
      modeVat:
        'Le contrôle de TVA reste à effectuer ; les appels VIES externes sont désactivés en mode introduction. La sélection intracommunautaire et la validation restent possibles.',
      taxPrerequisites:
        'La destination, le statut professionnel ou le type de fourniture ne justifie pas l’exonération. Vérifiez la décision fiscale.',
      transport:
        'La preuve de transport est requise pour la facture exonérée. Pour les devis et commandes, ce rappel concerne une étape ultérieure. Liez un bon de livraison ou une preuve appropriée avant de finaliser la facture.',
      overridePermission:
        'Vous ne pouvez pas déroger à la recommandation fiscale. Appliquez-la ou demandez un examen autorisé.',
      overrideReason:
        'Justifiez la dérogation fiscale avec au moins dix caractères et enregistrez le document.',
      technical:
        'Une erreur technique a empêché la finalisation. Rechargez le document et communiquez la référence au support.',
    },
    fields: {
      billingAddress_recipient: 'Destinataire',
      billingAddress_postalCode: 'Code postal de facturation',
      billingAddress_city: 'Ville de facturation',
      billingAddress_countryCode: 'Pays de facturation',
      shippingAddress_postalCode: 'Code postal de livraison',
      shippingAddress_city: 'Ville de livraison',
      documentDate: 'Date du document',
      items: 'Articles',
      taxStrategy: 'Décision fiscale',
      taxOverrideReason: 'Motif de dérogation fiscale',
    },
  },
  es: {
    advanceDeductibleTax: 'IVA deducible',
    advanceDeclaredPrepaid: 'Anticipo según factura del proveedor',
    advanceDeclaredDue: 'Pendiente según factura del proveedor',
    advanceOriginalReview: 'Revise los anticipos y el saldo en la factura original.',
    invoiceKind: 'Tipo de factura',
    standardInvoice: 'Factura',
    advanceRequest: 'Solicitud de anticipo',
    finalInvoice: 'Factura final',
    chooseAdvances: 'Seleccionar solicitudes de anticipo',
    previousPage: 'Anterior',
    nextPage: 'Siguiente',
    advanceReviewHint: 'El importe aplicado se revisa antes de la finalización.',
    advancePayment: 'Pago recibido',
    advanceReview: 'Revisar anticipos',
    advanceReviewFailed: 'La revisión de anticipos no está disponible.',
    advanceGross: 'Importe bruto aplicado',
    advanceNet: 'Neto',
    advanceTax: 'IVA',
    advanceDue: 'Importe pendiente',
    title: 'Cierre y requisitos',
    failed: 'Cierre fallido',
    succeeded: 'Documento cerrado',
    openCustomer: 'Verificar NIF-IVA en la ficha del cliente',
    openEvidence: 'Abrir pruebas en el archivo documental',
    correct: 'Corregir {{field}}',
    context:
      'Entorno: {{environment}} · Modo operativo: {{mode}} · Procedencia del documento: {{origin}}',
    TEST: 'Documento de prueba',
    UNMARKED: 'Sin asignación de prueba acreditada',
    unsaved: 'Cambios sin guardar: guarde el documento antes de cerrarlo.',
    checking: 'Comprobando requisitos …',
    checkFailed: 'La comprobación previa no está disponible. Repítala antes de cerrar.',
    ready: 'La versión guardada se puede cerrar. Todas las comprobaciones se repiten al ejecutar.',
    reload: 'Volver a cargar el documento',
    history: 'Intentos de cierre',
    historyFailed: 'No se pudo cargar el historial de intentos.',
    empty: 'Todavía no hay intentos de cierre.',
    issues: {
      permission: 'No tiene permiso para cerrar este documento. Contacte con su administrador.',
      version: 'El documento ha cambiado. Vuelva a cargarlo y revise los cambios.',
      locked: 'El documento ya está cerrado. Vuelva a cargar su estado actual.',
      status: 'Un documento anulado no se puede cerrar.',
      required:
        'Faltan campos obligatorios para este tipo de documento. Complete los campos indicados y guarde.',
      modeMissing:
        'Se desconoce el modo operativo. El administrador debe comprobar el estado del tenant.',
      modeCleanup:
        'Los cambios están bloqueados durante la limpieza. Espere a que termine o solicite al administrador que resuelva el fallo.',
      modeRecord:
        'El documento no pertenece a la fase operativa actual. Abra un documento de esta fase; los documentos históricos no se reclasifican.',
      vatUnavailable:
        'La última comprobación de IVA no estaba disponible. La selección intracomunitaria y la confirmación siguen siendo posibles; complete la comprobación en la ficha del cliente.',
      vatRequired:
        'Queda pendiente una acreditación de IVA válida y actual. La selección intracomunitaria y la confirmación siguen siendo posibles; verifique el NIF-IVA del cliente.',
      modeVat:
        'La comprobación de IVA está pendiente; las llamadas externas a VIES están desactivadas en modo de introducción. La selección intracomunitaria y la confirmación siguen siendo posibles.',
      taxPrerequisites:
        'El destino, la condición empresarial o el tipo de suministro no acredita la exención. Revise la decisión fiscal.',
      transport:
        'La prueba de transporte es necesaria para la factura exenta. En presupuestos y pedidos es un recordatorio para un paso posterior. Vincule un albarán o una prueba adecuada antes de cerrar la factura.',
      overridePermission:
        'No puede modificar la recomendación fiscal. Aplíquela o solicite una revisión autorizada.',
      overrideReason:
        'Justifique la excepción fiscal con al menos diez caracteres y guarde el documento.',
      technical:
        'Un error técnico impidió completar el cierre. Vuelva a cargar el documento y facilite la referencia al soporte.',
    },
    fields: {
      billingAddress_recipient: 'Destinatario',
      billingAddress_postalCode: 'Código postal de facturación',
      billingAddress_city: 'Ciudad de facturación',
      billingAddress_countryCode: 'País de facturación',
      shippingAddress_postalCode: 'Código postal de envío',
      shippingAddress_city: 'Ciudad de envío',
      documentDate: 'Fecha del documento',
      items: 'Posiciones',
      taxStrategy: 'Decisión fiscal',
      taxOverrideReason: 'Motivo de excepción fiscal',
    },
  },
  tr: {
    advanceDeductibleTax: 'İndirilebilir KDV',
    advanceDeclaredPrepaid: 'Tedarikçi belgesindeki avans',
    advanceDeclaredDue: 'Tedarikçi belgesindeki kalan tutar',
    advanceOriginalReview: 'Orijinal belgede avans ve kalan tutarı inceleyin.',
    invoiceKind: 'Fatura türü',
    standardInvoice: 'Fatura',
    advanceRequest: 'Avans talebi',
    finalInvoice: 'Nihai fatura',
    chooseAdvances: 'Avans taleplerini seçin',
    previousPage: 'Önceki',
    nextPage: 'Sonraki',
    advanceReviewHint: 'Mahsup edilen tutar kesinleştirmeden önce incelenir.',
    advancePayment: 'Ödeme alındı',
    advanceReview: 'Avansları inceleyin',
    advanceReviewFailed: 'Avans incelemesi kullanılamıyor.',
    advanceGross: 'Mahsup edilen brüt',
    advanceNet: 'Net',
    advanceTax: 'KDV',
    advanceDue: 'Ödenecek tutar',
    title: 'Kesinleştirme ve ön koşullar',
    failed: 'Kesinleştirme başarısız',
    succeeded: 'Belge kesinleştirildi',
    openCustomer: 'Müşteri kaydında KDV numarasını doğrula',
    openEvidence: 'Belge arşivinde kanıtları aç',
    correct: '{{field}} alanını düzelt',
    context: 'Ortam: {{environment}} · İşletim modu: {{mode}} · Belge kaynağı: {{origin}}',
    TEST: 'Test belgesi',
    UNMARKED: 'Kayıtlı test ataması yok',
    unsaved: 'Kaydedilmemiş değişiklikler: kesinleştirmeden önce belgeyi kaydedin.',
    checking: 'Ön koşullar denetleniyor …',
    checkFailed: 'Ön kontrol kullanılamıyor. Kesinleştirmeden önce tekrar deneyin.',
    ready: 'Kaydedilen sürüm kesinleştirilebilir. İşlem sırasında tüm kontroller tekrarlanır.',
    reload: 'Belgeyi yeniden yükle',
    history: 'Kesinleştirme denemeleri',
    historyFailed: 'Deneme geçmişi yüklenemedi.',
    empty: 'Henüz kesinleştirme denemesi yok.',
    issues: {
      permission: 'Bu belgeyi kesinleştirme yetkiniz yok. Yöneticinize başvurun.',
      version: 'Belge değişti. Yeniden yükleyip değişiklikleri inceleyin.',
      locked: 'Belge zaten kesinleştirilmiş. Güncel durumunu yeniden yükleyin.',
      status: 'İptal edilmiş belge kesinleştirilemez.',
      required:
        'Bu belge türü için zorunlu alanlar eksik. Belirtilen alanları tamamlayıp kaydedin.',
      modeMissing: 'İşletim modu bilinmiyor. Yönetici kiracı durumunu kontrol etmelidir.',
      modeCleanup:
        'Temizlik sırasında değişiklikler engellenir. Tamamlanmasını bekleyin veya hatanın giderilmesi için yöneticiye başvurun.',
      modeRecord:
        'Belge güncel işletim aşamasına ait değil. Bu aşamaya ait bir belge açın; geçmiş belgeler yeniden sınıflandırılmaz.',
      vatUnavailable:
        'Son KDV kimlik kontrolü kullanılamadı. Topluluk içi teslimat seçimi ve kesinleştirme mümkündür; kontrolü müşteri kaydında tamamlayın.',
      vatRequired:
        'Güncel ve geçerli KDV kimlik kanıtı hâlâ bekliyor. Topluluk içi teslimat seçimi ve kesinleştirme mümkündür; müşterinin KDV kimliğini kontrol edin.',
      modeVat:
        'KDV kimlik kontrolü bekliyor; başlangıç modunda dış VIES çağrıları kapalıdır. Topluluk içi teslimat seçimi ve kesinleştirme mümkündür.',
      taxPrerequisites:
        'Teslimat yeri, şirket niteliği veya tedarik türü vergi muafiyetini kanıtlamıyor. Vergi kararını inceleyin.',
      transport:
        'Vergiden muaf faturada taşıma kanıtı gerekir. Teklif ve siparişlerde bu, sonraki adım için hatırlatmadır. Faturayı kesinleştirmeden önce irsaliye veya uygun kanıt bağlayın.',
      overridePermission:
        'Vergi önerisinden sapma yetkiniz yok. Öneriyi uygulayın veya yetkili inceleme isteyin.',
      overrideReason:
        'Vergi önerisinden sapmayı en az on karakterle gerekçelendirip belgeyi kaydedin.',
      technical:
        'Teknik hata nedeniyle kesinleştirme tamamlanamadı. Belgeyi yeniden yükleyin ve hata referansını desteğe iletin.',
    },
    fields: {
      billingAddress_recipient: 'Alıcı',
      billingAddress_postalCode: 'Fatura posta kodu',
      billingAddress_city: 'Fatura şehri',
      billingAddress_countryCode: 'Fatura ülkesi',
      shippingAddress_postalCode: 'Teslimat posta kodu',
      shippingAddress_city: 'Teslimat şehri',
      documentDate: 'Belge tarihi',
      items: 'Kalemler',
      taxStrategy: 'Vergi kararı',
      taxOverrideReason: 'Vergi sapma gerekçesi',
    },
  },
} as const;
